import axios from "axios";
import { AppRoutesApi, AppRoutesUI } from "../../config/appRoutes";
import { ApiSchemaLogin } from "../../models/api/apiSchemaLogin";
import { AxiosAuth } from "../axios";
import { ApiResponseContainer } from "../../models/api/apiResponseContainer";
import { ResetPasswordFormType } from "../../models/forms/resetPasswordForm";

type ForgotPasswordType = {
  email: string;
};

type ProfileInfoType = {
  Id: string;
  FirstName: string;
  LastName: string;
  FullName: string;
  UserName: string;
  Email: string;
  Address: string;
  State: string;
  CountryId: string;
  TypeOfCompany: string;
  JobTitle: string;
  PhoneNumber: string;
  CountryName: string;
  CompanyName: string;
};

const login = async (email: string, password: string) => {
  return await axios.post<ApiSchemaLogin>(AppRoutesApi.Auth.Login, {
    email,
    password,
  });
};

const logOut = () => {
  window.location.href = AppRoutesUI.Auth.Login.Route;
};

const forgotPassword = async (email: string) => {
  return await axios.post<ForgotPasswordType>(
    AppRoutesApi.Auth.ForgotPassword,
    {
      email,
    }
  );
};

const resetPassword = async (resetPassword: ResetPasswordFormType) => {
  const res = await axios.post(AppRoutesApi.Auth.ResetPassword, resetPassword);
  return res.data;
};

const getProfileInfo = async () => {
  const res = await AxiosAuth.get<ApiResponseContainer<ProfileInfoType>>(
    AppRoutesApi.Auth.GetProfile
  );
  return res.data;
};

export const ApiAuth = {
  login,
  logOut,
  forgotPassword,
  resetPassword,
  getProfileInfo,
};
